<template>
    <div>
        <el-divider>CRC计算工具</el-divider>
        <vxe-input v-model="jiaMiQian" style="width:100%">
            <template #prefix>
                <span style="font-weight: bolder;">加密前</span>
            </template>
        </vxe-input>
        <el-row type="flex" justify="center">
            <vxe-button style="margin-top: 10px;" status="primary" content="计算结果" @click="getTodayPWD"></vxe-button></el-row>
        <vxe-result :title="jiaMiHou" v-if="showResult" icon="vxe-icon-check" content="计算结果" status="success"></vxe-result>
    </div>
</template>

<script>
export default {
    data() {
        return {
            jiaMiQian: "",
            jiaMiHou: "",
            showResult: false
        };
    },
    methods: {
        getTodayPWD() {
            let that = this;
            that.showResult = false;
            that.axios.post("CRC_Tools/GetTodayPWD", { onlyText: that.jiaMiQian }).then((response) => {
                that.jiaMiQian = response.data.data.jiaMiQian;
                that.jiaMiHou = response.data.data.jiaMiHou;
                that.showResult = true;
            });
        }

    },
    mounted() {
        let that = this;
        that.getTodayPWD();
    }
};
</script>

<style></style>